// extracted by mini-css-extract-plugin
export default {"buttons":"K8jentS6aXHlV2UmLK97","steps":"Fuyy9KM6ZsUOKei9uRVJ","buttonsHolder":"WiGUKd7BviLGpP19jFMp"};